import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppServiceService } from 'src/app/_services/app-service.service';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-vendor-all-comp',
  templateUrl: './vendor-all-comp.component.html',
  styleUrls: ['./vendor-all-comp.component.css']
})
export class VendorAllCompComponent implements OnInit {

  @Output() toggleSidebarForMe: EventEmitter<any> = new EventEmitter();

  screenWidth: number;
  sideBarOpen = true;
  scrollPosition: number;
  constructor(private appService: AppServiceService,
    private authService: AuthService,
    private router: Router) {
    this.screenWidth = window.innerWidth;
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
    };
  }

  sideBarToggler() {
    this.sideBarOpen = !this.sideBarOpen;
  }

  toggleSidebar() {
    this.toggleSidebarForMe.emit();
  }

  ngOnInit(): void {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      // Scroll to the top of the page
      window.scrollTo(0, 0);
    });
  }
}
